import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import CustomReveal from './../../common/reveal/CustomReveal';
import { SmartButton } from '../../common/SmartButton';
import CustomIcon from '../../../components/common/CustomIcon';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import * as taskActions from '../../../actions/taskActions';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import { bindActionCreators } from 'redux';
import UserList from '../../classroom/students/AddUsers/UserList';

class AssignmentsContentPanelModal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    assignmentsDrawerActions: PropTypes.any,
    students: PropTypes.array,
    taskActions: PropTypes.any,
    sendObject: PropTypes.object
  };

  closeModal = () => {
    this.props.revealActions.openStudentsWithoutAssignmentInLessons(false);
  };

  submit = () => {
    const { assignmentsDrawerActions, sendObject } = this.props;
    assignmentsDrawerActions.createAssignment(sendObject.assignment, sendObject.selectedClassroomId).then(() => {
      taskActions.getAllTasks(sendObject.selectedClassroomId);
      this.props.revealActions.openStudentsWithoutAssignmentInLessons(false);
    });
  };

  render() {
    const { students } = this.props;

    return (
      <CustomReveal id="not-assignment-lesson" active close={this.closeModal}>
        <div className="parent">
          <div className="header">
            <span className="close-btn" onClick={this.closeModal}>
              <CustomIcon name="close-button" size={24} />
            </span>
            <span className="title">{I18n.t('studentsWithoutAssignmentInLessons.title')}</span>
          </div>

          <div className="content">
            <br />
            <br />
            <UserList users={students} />
            <br />
            <br />
          </div>

          <div className="footer">
            <div className="footer-content">
              <SmartButton onClick={this.closeModal}>{I18n.t('common.cancel')}</SmartButton>
              <SmartButton success onClick={this.submit}>
                {I18n.t('common.option.createTask')}
              </SmartButton>
            </div>
          </div>
        </div>
      </CustomReveal>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    students: state.reveal.students,
    sendObject: state.reveal.sendObject
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsContentPanelModal);
